import * as LucideIcons from "lucide-react";

const Icon = (props) => {
    try {
        // Get the icon component, fallback to CircleHelp if not found
        const LucideIcon = LucideIcons[props.name] || LucideIcons.CircleHelp;

        if (!LucideIcon) {
            console.warn(`Icon "${props.name}" not found in lucide-react`);
            return null;
        }

        return <LucideIcon {...props} />;
    } catch (error) {
        console.error(`Error rendering icon "${props.name}":`, error);
        return null;
    }
};

export default Icon;
